export const IMAGES = {
  hero: '/assets/pdf/render-day.webp',
  renderNight: '/assets/pdf/render-night.webp',
  palmArch: '/assets/palm-architecture.webp',
  pool: '/assets/pdf/pool-deck.webp',
  poolLifestyle: '/assets/pdf/pool-lifestyle.webp',
  balcony: '/assets/balcony-living.webp',
  clubhouse: '/assets/pdf/clubhouse-render.webp',
  kidsSlide: '/assets/pdf/kids-slide.webp',
  climbingWall: '/assets/pdf/climbing-wall.webp',
  jogging: '/assets/pdf/jogging-track.webp',
  gazebo: '/assets/pdf/gazebo.webp',
  reflexology: '/assets/pdf/reflexology.webp',
  seniorsPark: '/assets/pdf/seniors-park.webp',
  corridor: '/assets/pdf/corridor.webp',
  builderProject: '/assets/pdf/builder-project.webp',
  masterPlan: '/assets/master-plan.webp',
  locationMap: '/assets/location-map.webp',
  siteOffice: '/assets/site-office.webp',
};

export const HIGHLIGHTS = [
  { num: '16', unit: 'Acres', label: 'Themed Tropical Ecosystem', text: 'A 16-acre themed tropical residential ecosystem on Kalyan–Shilphata Road.' },
  { num: '70', unit: '%', label: 'Open Spaces', text: 'Nearly three-fourths of the development is reserved as open, landscaped space.' },
  { num: '60', unit: '+', label: 'World-Class Amenities', text: 'Lifestyle, recreation, wellness and community amenities across all age groups.' },
  { num: '30', unit: '', label: 'Palm Varieties', text: 'A curated tropical landscape with 30 varieties of palm trees.' },
  { num: '1·2·2.5', unit: '', label: 'BHK Homes', text: 'Spacious 1, 2 and 2.5 bed homes designed for modern families.' },
  { num: '100', unit: '%', label: 'Homes with Balconies', text: 'Every residence is planned with a balcony to bring the outdoors in.' },
];

export const CONFIGS = [
  {
    slug: '1-bhk',
    name: '1 BHK',
    carpet: '406 – 453 sq.ft.',
    price: '₹52 L onwards*',
    priceNote: 'All-inclusive, floors 1–10',
    who: 'First-time buyers, young professionals and investors',
    blurb: 'A smart, efficient home with a balcony — ideal as a first home or a high-demand rental asset in the Shilphata growth corridor.',
  },
  {
    slug: '2-bhk',
    name: '2 BHK',
    carpet: '637 sq.ft.',
    price: '₹83 L onwards*',
    priceNote: 'All-inclusive, floors 1–10',
    who: 'Growing families and work-from-home couples',
    blurb: 'A comfortable family home with a balcony, generous living spaces and access to 60+ amenities across the 16-acre ecosystem.',
  },
  {
    slug: '2-5-bhk',
    name: '2.5 BHK',
    carpet: '811 sq.ft.',
    price: '₹1.12 Cr onwards*',
    priceNote: 'All-inclusive, floors 1–10',
    who: 'Larger families needing a flexible extra room',
    blurb: 'An expansive residence with an additional flexible room — a study, kids’ room or home office — plus a balcony and tropical views.',
  },
];

export const PRICING = [
  { type: '1 BHK', carpet: '406 sq.ft.', agreement: '₹48,61,132', f1: '₹52,00,000', f2: '₹53,00,000', f3: '₹54,00,000' },
  { type: '1 BHK', carpet: '453 sq.ft.', agreement: '₹54,27,170', f1: '₹58,00,000', f2: '₹59,00,000', f3: '₹60,00,000' },
  { type: '2 BHK', carpet: '637 sq.ft.', agreement: '₹77,85,660', f1: '₹83,00,000', f2: '₹84,00,000', f3: '₹85,00,000' },
  { type: '2.5 BHK', carpet: '811 sq.ft.', agreement: '₹1,05,21,509', f1: '₹1,12,00,000', f2: '₹1,13,00,000', f3: '₹1,14,00,000' },
];

export const PRICING_NOTES = [
  'Prices are as per the latest cost sheet and include a mandatory car parking.',
  'Additional spot offer applicable on same-day booking.',
  'Price is subject to change based on existing offers. Government charges are subject to change as per actuals without intimation.',
  'Contact us for the current pricing, applicable offers and availability.',
];

export const AMENITIES = [
  {
    cat: 'Kids',
    items: ['Kids Play Area', 'Climbing Wall', 'Cricket Nets', 'Tricycle Track', 'Floor Games', 'Labyrinth', 'Kids Pool', 'Lower Deck'],
  },
  {
    cat: 'Fitness & Wellness',
    items: ['Jogging / Walking Track', 'Swimming Pool', 'Multi-Play Court', 'Reflexology Pathway', 'Putting Lawn', 'Upper Deck'],
  },
  {
    cat: 'Seniors',
    items: ["Senior's Deck", "Senior's Spill Over Lawn", 'Reading / Working Cove', 'Ledge Seating', 'Cove Seats', "Spectators' Seat"],
  },
  {
    cat: 'Community & Leisure',
    items: ['Cafe Deck', 'Cafe Spill Over', 'Wi-Fi Lounge', 'Lounge Deck', 'Gazebo', 'Water Edge', 'Trellis Walk', "Parents' Seating", 'Connecting Staircase'],
  },
  {
    cat: 'Landscape',
    items: ['Plantation Island', 'Layered Plantation', 'Sensory Trail', 'Secret Garden'],
  },
];

export const CONNECTIVITY = [
  {
    cat: 'Connectivity',
    items: [
      { name: 'Kalyan–Shilphata Road', time: '40 m' },
      { name: 'Panvel Road', time: '800 m' },
    ],
  },
  {
    cat: 'Healthcare',
    items: [
      { name: 'GHC Hospitals', time: '3.7 km' },
      { name: 'Arnavi Hospital', time: '5.5 km' },
      { name: 'Metro Hospital', time: '6.3 km' },
      { name: 'Kokilaben Ambani Hospital', time: '8.8 km' },
    ],
  },
  {
    cat: 'Business & Employment',
    items: [
      { name: 'Hexaware Technology', time: '7.8 km' },
      { name: 'United Info Tech Park', time: '7.9 km' },
      { name: 'Dhirubhai Ambani Knowledge City', time: '10 km' },
      { name: 'Loma IT Park', time: '10 km' },
    ],
  },
  {
    cat: 'Education',
    items: [
      { name: 'Eurokids Preschool', time: '2.3 km' },
      { name: 'Guardians School (CBSE)', time: '2.3 km' },
      { name: 'Lodha World School', time: '4.7 km' },
      { name: 'Government Polytechnic', time: '3.8 km' },
    ],
  },
];

export const LOCATION_EXTRA = [
  {
    cat: 'Entertainment',
    items: [
      { name: 'Experia Mall', time: '4.9 km' },
      { name: 'Central Mall', time: '5.4 km' },
      { name: 'INOX Cinemas', time: '11.9 km' },
      { name: 'PVR Cinemas', time: '12 km' },
    ],
  },
  {
    cat: 'Places of Worship',
    items: [
      { name: 'Shree Dutt Mandir', time: '1.5 km' },
      { name: 'Ram Mandir', time: '1.7 km' },
    ],
  },
  {
    cat: 'Colleges',
    items: [
      { name: 'Government Polytechnic', time: '3.8 km' },
      { name: 'Global Jr. College', time: '6.9 km' },
      { name: 'Swami Vivekanand Jr. College', time: '9.1 km' },
    ],
  },
];

export const INFRASTRUCTURE = [
  { name: 'Kalyan–Taloja Metro Line', status: 'Proposed', text: 'A proposed metro corridor connecting Kalyan to Taloja, referenced in the official Provident Housing project material as a future connectivity driver for Shilphata. Verify current status independently.' },
  { name: 'Airoli–Katai Tunnel', status: 'Upcoming', text: 'Highlighted in the official project material as improving access between Shilphata and the Airoli business district of Navi Mumbai. Verify current status independently.' },
  { name: 'Vasai–Panvel Rail Expansion', status: 'Proposed', text: 'A proposed rail expansion referenced in the official project material, set to strengthen suburban rail connectivity for the wider node. Verify current status independently.' },
  { name: 'Thane–Dombivli Bridge', status: 'Upcoming', text: 'Referenced in the official project material as improving east–west connectivity between the Thane and Dombivli sides of the region. Verify current status independently.' },
  { name: 'Kalyan–Shil Road', status: 'Existing corridor', text: 'The project sits on Kalyan–Shilphata Road (40 m from the site), the existing spine connecting Shilphata towards Thane on one side and Panvel on the other.' },
  { name: 'Navi Mumbai Business Districts', status: 'Existing', text: 'Shilphata connects to the established Navi Mumbai employment districts of Airoli, Koparkhairne and Vashi, including Dhirubhai Ambani Knowledge City, Loma IT Park, United Info Tech Park and Hexaware Technology.' },
];

export const RERA_LIST = [
  { wing: 'B1', rera: 'P51700025841' },
  { wing: 'B2', rera: 'P51700025839' },
  { wing: 'C1', rera: 'P51700025840' },
  { wing: 'C2', rera: 'P51700025864' },
  { wing: 'D1', rera: 'P51700025844' },
  { wing: 'D2', rera: 'P51700025854' },
  { wing: 'D3', rera: 'P51700025849' },
  { wing: 'D4', rera: 'P51700025842' },
];

export const FAQS = [
  { q: 'What is Provident Palm Vista?', a: 'Provident Palm Vista is a 16-acre themed tropical residential ecosystem by Provident Housing (a Puravankara company), located on Kalyan–Shilphata Road, Mumbai. It offers spacious 1, 2 and 2.5 BHK homes with balconies, 70% open spaces, 60+ amenities and landscaping with 30 varieties of palm trees.' },
  { q: 'Where is Provident Palm Vista located?', a: 'Provident Palm Vista is located next to Indian Oil Pump on Kalyan–Shilphata Road, Mumbai – 421204, Maharashtra — about 5 minutes from Shilphata Junction. See the Provident Palm Vista location page for full connectivity details.' },
  { q: 'What configurations are available at Provident Palm Vista?', a: 'The project offers 1 BHK (406–453 sq.ft. carpet), 2 BHK (637 sq.ft. carpet) and 2.5 BHK (811 sq.ft. carpet) homes, all designed with balconies.' },
  { q: 'Does Provident Palm Vista offer 1 BHK homes?', a: 'Yes. Provident Palm Vista offers 1 BHK homes in two carpet-area options — 406 sq.ft. and 453 sq.ft. — each with a balcony. Visit the 1 BHK page for details and current pricing.' },
  { q: 'Does Provident Palm Vista offer 2 BHK homes?', a: 'Yes. The 2 BHK homes at Provident Palm Vista offer a 637 sq.ft. carpet area with a balcony, suited to growing families. Visit the 2 BHK page for details.' },
  { q: 'Does Provident Palm Vista offer 2.5 BHK homes?', a: 'Yes. The 2.5 BHK residences offer an 811 sq.ft. carpet area with an additional flexible room and a balcony — ideal for larger families or a home office. Visit the 2.5 BHK page for details.' },
  { q: 'How large is Provident Palm Vista?', a: 'The development is spread across 16 acres, with approximately 70% of the project reserved as open spaces and tropical landscaping.' },
  { q: 'How many amenities are available?', a: 'Provident Palm Vista offers 60+ world-class amenities across zones for kids, fitness and wellness, seniors, community and leisure, and themed landscape experiences.' },
  { q: 'Does Provident Palm Vista have balconies?', a: 'Yes. The homes at Provident Palm Vista are designed with balconies, extending the living space into the tropical landscape.' },
  { q: 'What are the nearby schools?', a: 'Schools near the project include Eurokids Preschool (2.3 km), Guardians School – CBSE (2.3 km) and Lodha World School (4.7 km). Nearby colleges include Government Polytechnic (3.8 km), Global Jr. College (6.9 km) and Swami Vivekanand Jr. College (9.1 km). Distances are as per official project material.' },
  { q: 'What are the nearby hospitals?', a: 'Hospitals near the project include GHC Hospitals (3.7 km), Arnavi Hospital (5.5 km), Metro Hospital (6.3 km) and Kokilaben Ambani Hospital (8.8 km). Distances are as per official project material.' },
  { q: 'How is Palm Vista connected to Thane?', a: 'The project sits on Kalyan–Shilphata Road (40 m from the site), the corridor connecting Shilphata towards Thane on one side and Panvel on the other. The official project material also references the upcoming Thane–Dombivli bridge and the proposed Kalyan–Taloja metro line.' },
  { q: 'How is Palm Vista connected to Navi Mumbai?', a: 'Shilphata connects to the Navi Mumbai business districts of Airoli, Koparkhairne and Vashi. Corporate destinations near the project include Hexaware Technology (7.8 km), United Info Tech Park (7.9 km), Dhirubhai Ambani Knowledge City (10 km) and Loma IT Park (10 km).' },
  { q: 'What is the RERA number of Provident Palm Vista?', a: 'The project is registered under MahaRERA across wings: B1 – P51700025841, B2 – P51700025839, C1 – P51700025840, C2 – P51700025864, D1 – P51700025844, D2 – P51700025854, D3 – P51700025849, D4 – P51700025842. See the RERA page for details.' },
  { q: 'How can I get the Provident Palm Vista brochure?', a: 'Submit the enquiry form or message us on WhatsApp at +91 88798 56585 and we will share the latest Provident Palm Vista brochure and project details.' },
  { q: 'How can I request the latest price?', a: 'You can view indicative pricing on the price page, and request the current cost sheet, applicable offers and availability via the enquiry form, WhatsApp or by calling +91 88798 56585.' },
  { q: 'How can I book a site visit?', a: 'Use the Book a Site Visit option on any page, or reach us on WhatsApp or call +91 88798 56585. Our team will confirm a convenient slot for your visit to the site on Kalyan–Shilphata Road.' },
];

export const GALLERY = [
  { src: IMAGES.masterPlan, alt: 'Provident Palm Vista master plan showing towers and clubhouse', cat: 'Floor Plans', w: 664, h: 849 },
  { src: IMAGES.hero, alt: 'Provident Palm Vista Shilphata tower elevation render — day view', cat: 'Exterior', w: 1039, h: 1039 },
  { src: IMAGES.clubhouse, alt: 'Provident Palm Vista clubhouse and labyrinth garden render', cat: 'Amenities', w: 1486, h: 836 },
  { src: IMAGES.poolLifestyle, alt: 'Poolside lifestyle at Provident Palm Vista', cat: 'Lifestyle', w: 851, h: 1193 },
  { src: IMAGES.pool, alt: 'Swimming pool at Provident Palm Vista', cat: 'Amenities', w: 848, h: 566 },
  { src: IMAGES.kidsSlide, alt: 'Kids play area with slide at Provident Palm Vista', cat: 'Amenities', w: 551, h: 368 },
  { src: IMAGES.climbingWall, alt: 'Climbing wall amenity at Provident Palm Vista', cat: 'Amenities', w: 431, h: 646 },
  { src: IMAGES.jogging, alt: 'Jogging track through tropical landscape at Provident Palm Vista', cat: 'Amenities', w: 622, h: 415 },
  { src: IMAGES.gazebo, alt: 'Gazebo sit-out in landscaped gardens at Provident Palm Vista', cat: 'Landscape', w: 424, h: 285 },
  { src: IMAGES.reflexology, alt: 'Reflexology pathway at Provident Palm Vista', cat: 'Landscape', w: 420, h: 280 },
  { src: IMAGES.seniorsPark, alt: "Senior citizens' deck and seating at Provident Palm Vista", cat: 'Lifestyle', w: 436, h: 291 },
  { src: IMAGES.renderNight, alt: 'Provident Palm Vista tower render — evening view', cat: 'Exterior', w: 362, h: 434 },
  { src: IMAGES.siteOffice, alt: 'Provident Palm Vista site experience centre exterior', cat: 'Exterior', w: 1080, h: 875 },
  { src: IMAGES.locationMap, alt: 'Provident Palm Vista location growth map for Shilphata micro-market', cat: 'Location', w: 1080, h: 1344 },
  { src: IMAGES.corridor, alt: 'Connectivity corridors linking Shilphata to the Mumbai region', cat: 'Location', w: 1377, h: 979 },
  { src: IMAGES.balcony, alt: 'Balcony living at Provident Palm Vista homes', cat: 'Lifestyle', w: 1200, h: 800 },
  { src: IMAGES.palmArch, alt: 'Palm-lined tropical landscaping at Provident Palm Vista', cat: 'Landscape', w: 1200, h: 1800 },
];

export const GALLERY_CATS = ['All', 'Exterior', 'Lifestyle', 'Amenities', 'Landscape', 'Floor Plans', 'Location'];

export const BUILDER_STATS = [
  { num: '49', label: 'Years of real estate experience' },
  { num: '09', label: 'Indian cities of presence' },
  { num: '83+', label: 'Iconic projects' },
  { num: '42,500+', label: 'Homes delivered' },
];
